<template>
    <div class="ds-up-module" :style="{ backgroundImage: `url(${BannerImg})` }">
      <div class="ds-up-module-content">
        <div class="ds-up-item pd-top-120">
          <div class="display-flex">
            <div class="left">
              <div class="blue-title">赋能</div>
              <div>供应链</div>
            </div>
            <div class="right">
              <img :src="DsUpImg" alt="">
            </div>
          </div>
          <div class="item-ilne">
            <img class="item-ilne-icon" :src="CancelImg" alt="">
            <span>实现供应链的短化和直连，减少中间环节，降低成本</span>
          </div>
          <div class="item-ilne">
            <img class="item-ilne-icon" :src="CancelImg" alt="">
            <span>实时库存管理和智能补货，减少库存积压和缺货风险</span>
          </div>
        </div>
        <div class="ds-up-item">
          <div class="display-flex">
            <div class="left">
              <div class="blue-title">赋能</div>
              <div>客户关系</div>
            </div>
            <div class="right">
              <img :src="DsUpImg" alt="">
            </div>
          </div>
          <div class="item-ilne">
            <img class="item-ilne-icon" :src="CancelImg" alt="">
            <span>大数据分析，消费者行为预测，指导生产和销售决策</span>
          </div>
          <div class="item-ilne">
            <img class="item-ilne-icon" :src="CancelImg" alt="">
            <span>CRM了解客户需求，提供个性化服务，增强客户忠诚度</span>
          </div>
        </div>
        <div class="ds-up-item">
          <div class="display-flex">
            <div class="left">
              <div class="blue-title">赋能</div>
              <div>交易通路</div>
            </div>
            <div class="right">
              <img :src="DsUpImg" alt="">
            </div>
          </div>
          <div class="item-ilne">
            <img class="item-ilne-icon" :src="CancelImg" alt="">
            <span>自动化的订单处理流程，减少人工错误</span>
          </div>
          <div class="item-ilne">
            <img class="item-ilne-icon" :src="CancelImg" alt="">
            <span>电子合同和电子支付的使用，简化交易流程，缩短交易周期</span>
          </div>
        </div>
        <div class="ds-up-item pd-top-120">
          <div class="display-flex">
            <div class="left">
              <div class="blue-title">赋能</div>
              <div>服务</div>
            </div>
            <div class="right">
              <img :src="DsUpImg" alt="">
            </div>
          </div>
          <div class="item-ilne">
            <img class="item-ilne-icon" :src="CancelImg" alt="">
            <span>供应链金融，缓解企业现金流压力</span>
          </div>
          <div class="item-ilne">
            <img class="item-ilne-icon" :src="CancelImg" alt="">
            <span>财税结算，实现业财一体化</span>
          </div>
          <div class="item-ilne">
            <img class="item-ilne-icon" :src="CancelImg" alt="">
            <span>物流服务，实时掌握货品物流流向</span>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Banner from '@/assets/product/digitalSystem/up-banner.png'
import DsUp from '@/assets/product/svgIcon/ds-up.svg'
import Cancel from '@/assets/product/digitalSystem/cancel-icon.png'
export default {
   data() {
      return {
        BannerImg: Banner,
        DsUpImg: DsUp,
        CancelImg: Cancel,
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.ds-up-module {
  height: 494px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: 0 174px;
  padding-right: 40px;
}
.ds-up-module-content {
  display: flex;
  justify-content: space-between;
}
.ds-up-item {
  width: 238px;
  height: 188px;
}
.display-flex {
  display: flex;
  margin-bottom: 30px;
}
.left {
  font-weight: bold;
  font-size: 28px;
  color: #222222;
  line-height: 30px;
  padding-left: 28px;
}
.left .blue-title {
  font-weight: bold;
  font-size: 18px;
  color: #0367FF;
  padding-left: 48px;
  margin-right: 8px;
}
.right img {
  width: 36px;
  height: 52px;
}
.item-ilne {
  margin-bottom: 18px;
  display: flex;
  text-align: left;
}
.item-ilne-icon {
  width: 16px;
  height: 11px;
  margin-right: 5px;
}
.pd-top-120 {
  padding-top: 120px;
}
</style>
